import { styled } from 'styled-components'

export const POPUP_PAPER_STYLES = {
  '& .MuiDialog-paper': { borderRadius: '16px' },
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 436px;
  padding: 24px 20px 64px;
`

export const CloseButton = styled.button`
  align-self: flex-end;
  display: flex;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.grayDark};
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const Title = styled.h2`
  margin: 20px 0 40px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
`

export const QrCode = styled.div`
  box-sizing: border-box;
  width: 240px;
  padding: 14px;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
